import { useLocalStorage } from "usehooks-ts";

const useLocalStorageGridState = <T,>(key: string, initialState: T) =>
  useLocalStorage<T>(key, initialState);
export default useLocalStorageGridState;
